import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';

import {
  getUsers as getUsersApi,
  getOneUserLimited as getOneUserApi,
  getLimitedUsers as getLimitedUsersApi,
  deleteUser as deleteUserApi,
} from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import {
  REQUEST_USERS,
  REQUEST_LIMITED_USERS,
  REQUEST_USER,
  DELETE_USER,
  receiveUser,
  receiveUsers,
  receiveLimitedUsers,
} from './actions';
import { requestMembers } from '../auth/actions';

export function* doRequestUser(action) {
  try {
    const { oid } = action;
    const user = yield call(getOneUserApi, oid);

    yield put(receiveUser(oid, user));
  } catch (error) {
    console.error('Unable to fetch user:', error);
    yield call(checkOnline);
  }
}

export function* doRequestUsers() {
  try {
    const { values: users } = yield call(getUsersApi, { limit: 0 });
    yield put(receiveUsers(Object.fromEntries(users.map((user) => [user.id, user]))));
  } catch (error) {
    console.error('Unable to fetch users:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getUsers', 'error')()));
  }
}

export function* doRequestLimitedUsers(action) {
  try {
    const { siteId } = action;
    const { values: users } = yield call(getLimitedUsersApi, { site: siteId });
    yield put(receiveLimitedUsers(users));
  } catch (error) {
    console.error('Unable to fetch users:', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getUsers', 'error')()));
  }
}

export function* doDeleteUser(action) {
  try {
    const { oid } = action;
    yield call(deleteUserApi, oid);
    yield put(requestMembers(undefined, true));
    yield put(displayNotification(getNotification('deleteUser', 'success')(oid)));
  } catch (error) {
    console.error('Unable to delete user:', error?.message);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('deleteUser', 'error')(error?.message)));
  }
}

export const sagas = [
  takeEvery(REQUEST_USER, doRequestUser),
  takeLatest(REQUEST_USERS, doRequestUsers),
  takeLatest(REQUEST_LIMITED_USERS, doRequestLimitedUsers),
  takeLatest(DELETE_USER, doDeleteUser),
];
